/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateQuestionTypesControllerFindOneQueryResponse, TemplateQuestionTypesControllerFindOnePathParams, TemplateQuestionTypesControllerFindOneQueryParams, TemplateQuestionTypesControllerFindOne400, TemplateQuestionTypesControllerFindOne401, TemplateQuestionTypesControllerFindOne403, TemplateQuestionTypesControllerFindOne404 } from "../../models/checklistsController/TemplateQuestionTypesControllerFindOne";

function getTemplateQuestionTypesControllerFindOneUrl(id: TemplateQuestionTypesControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-template-question-types/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist template question type by ID
 * {@link /api/v1/checklist-template-question-types/:id}
 */
export async function templateQuestionTypesControllerFindOne(id: TemplateQuestionTypesControllerFindOnePathParams["id"], params?: TemplateQuestionTypesControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateQuestionTypesControllerFindOneQueryResponse, ResponseErrorConfig<TemplateQuestionTypesControllerFindOne400 | TemplateQuestionTypesControllerFindOne401 | TemplateQuestionTypesControllerFindOne403 | TemplateQuestionTypesControllerFindOne404>, unknown>({ method : "GET", url : getTemplateQuestionTypesControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}